/**
 * @summary
<blockquote>Data access levels for RBAC permissions</blockquote>
 * @internal
 */
export const DATA_ACCESS_LEVELS = {
  NONE: 'none',
  OWN: 'own',
  TENANT: 'tenant',
  ROLE: 'role',
  ALL: 'all'
} as const; 